import { configParams } from "../configParams";
import { consecutiveMovementsArr } from "./consecutiveMovementsArr";
import { dotMovement } from "./dotAnimation";
import { proofValidation } from "./proofValidation";
import { vectorReading } from "./vectorReading";

export const dataProcessing = (
  vectors,
  arrOfMovements,
  isTestFinished,
  diffVectors,
  test
) => {
  if (vectors.mouth.length > 1) {
    const checked = document.getElementsByClassName("checked")[0];
    const currentMovement = vectorReading(vectors, diffVectors, configParams);

    const arrOfConsecutiveMoves = consecutiveMovementsArr(
      currentMovement,
      arrOfMovements
    );

    dotMovement(test);

    checked.style.animationName = "none";

    proofValidation(test, arrOfConsecutiveMoves, isTestFinished);
  }
};
